import type { UserSort } from '@simppl/repository-admin/common';
import LoginStorage from '@simppl/repository-admin/user/LoginStorage';
import { type PropsWithChildren } from 'react';
import type { NavigateProps } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import useAdminUserInfo from '../hook/useAdminUserInfo';
import { type PermissionKey, canAccessByPermissions } from '../utils/permission';

const LoginRequired = ({
  children,
  to = '/login',
  replace,
  state,
  relative,
  requiredPermissions,
}: PropsWithChildren<
  Omit<NavigateProps, 'to'> & { to?: NavigateProps['to']; requiredPermissions?: PermissionKey[] }
>) => {
  const isLoggedIn = LoginStorage.isLogin();

  const userInfo = useAdminUserInfo();
  const userSort = userInfo?.status as UserSort | undefined;

  // 로그인하지 않은 경우 로그인 페이지로
  if (!isLoggedIn) {
    return (
      <Navigate
        to={to}
        replace={replace}
        state={state}
        relative={relative}
      />
    );
  }

  // ✅ 권한이 필요한 라우트만 체크
  if (requiredPermissions && requiredPermissions.length > 0) {
    const hasAccess = canAccessByPermissions(userSort, requiredPermissions);

    if (!hasAccess) {
      return (
        <div className='flex min-h-screen flex-col items-center justify-center'>
          <h1 className='text-2xl font-bold'>접근 권한이 없습니다</h1>
          <p className='mt-4 text-gray-600'>이 페이지에 접근할 권한이 없습니다.</p>
          <button
            onClick={() => window.history.back()}
            className='mt-6 rounded-lg bg-blue-500 px-6 py-2 text-white hover:bg-blue-600'
          >
            뒤로가기
          </button>
        </div>
      );
    }
  }

  return <>{children}</>;
};

export default LoginRequired;
